import React, { useEffect, useState, useContext } from 'react';
import { Col, Row, Button, Modal, Form, Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { BsPlus, BsTrash, BsPencil } from 'react-icons/bs';
import { MdSearch, MdFilterList } from 'react-icons/md';
import Breadcrumbs from '../../components/layout/breadcrumbs';
import Page from '../../components/page';
import { api } from '../../providers/apiClient';
import { ContextUser } from '../../providers/ContextUser';
import { ContextSearch } from '../../providers/ContextSearch';
import Search from '../../components/search';
import NoResults from '../../components/no-result';
import { toast } from 'react-toastify';
import enumUserRole from '../../enum/enumUserRole';
import {
  UsersContainer,
  UsersHeader,
  SearchSection,
  FilterButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Select,
  ButtonGroup,
  ActionButton,
  DeleteButton,
  EditButton,
  AddButton,
  CustomButton,
  ListActionButton,
  // novos estilos de grade
  Container,
  TableBox,
  CustomTable,
  CustomTableHead,
  CustomTableBody,
  CustomTableRow,
  CustomTH,
  CustomTD,
  ActionsTH,
  FilterSection as GridFilterSection,
  FilterContainer,
  FilterInputContainer,
  FilterSelectContainer,
  CustomInputGroup,
  SearchIconBox,
  CustomFormControl,
  CustomSelectRounded,
  StatusBadge,
} from './styles';

const PageUsers = ({ isCollapsed }) => {
  const { orgId, branchId, unitId, departmentId } = useParams();
  const { currentUser, currentOrganization } = useContext(ContextUser);
  const { searchValues, setSearchValues, clearPageFilters } = useContext(ContextSearch);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [users, setUsers] = useState([]);
  const [searchUserResult, setSearchUserResult] = useState([]);
  // filtros no cabeçalho (estilo Service Desk)
  const [headerFilters, setHeaderFilters] = useState({
    text: '',
    role: '',
  });
  const [organizations, setOrganizations] = useState([]);
  const [branches, setBranches] = useState([]);
  const [units, setUnits] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [currentBranch, setCurrentBranch] = useState(null);
  const [currentUnit, setCurrentUnit] = useState(null);
  const [currentDepartment, setCurrentDepartment] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    lastName: '',
    email: '',
    docNumber: '',
    jobTitle: '',
    internalCod: '',
    phoneDDD: '',
    phoneNumber: '',
    role: '',
    organizationId: '',
    branchId: '',
    unitId: '',
    departmentId: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [phoneValue, setPhoneValue] = useState('');

  // Função para aplicar máscara de telefone
  const applyPhoneMask = (value) => {
    // Remove todos os caracteres não numéricos
    const numbers = value.replace(/\D/g, '');
    
    // Aplica a máscara conforme o usuário digita
    if (numbers.length <= 2) {
      return `(${numbers}`;
    } else if (numbers.length <= 7) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    } else if (numbers.length <= 11) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
    } else {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
    }
  };

  // Função para formatar CPF
  const formatCPF = (cpf) => {
    if (!cpf) return '';
    // Remove todos os caracteres não numéricos
    const numbers = cpf.replace(/\D/g, '');
    // Aplica a máscara do CPF: 000.000.000-00
    if (numbers.length <= 3) {
      return numbers;
    } else if (numbers.length <= 6) {
      return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
    } else if (numbers.length <= 9) {
      return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`;
    } else {
      return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`;
    }
  };

  // Função para limpar erros específicos
  const clearFieldError = (fieldName) => {
    if (formErrors[fieldName]) {
      setFormErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  // Determina o nível hierárquico atual baseado nos parâmetros da URL
  const getCurrentHierarchyLevel = () => {
    if (departmentId) return 'DEPARTMENT';
    if (unitId) return 'UNIT';
    if (branchId) return 'BRANCH';
    if (orgId) return 'ORG';
    return 'ADMIN';
  };

  // Determina quais campos são obrigatórios baseados no perfil selecionado
  const getRequiredFieldsByRole = (role) => {
    switch (role) {
      case 'ADMIN':
        return { organizationId: false, branchId: false, unitId: false, departmentId: false };
      case 'ACCESS_ORG_LEVEL':
        return { organizationId: true, branchId: false, unitId: false, departmentId: false };
      case 'ACCESS_BRANCH_LEVEL':
        return { organizationId: true, branchId: true, unitId: false, departmentId: false };
      case 'ACCESS_UNIT_LEVEL':
        return { organizationId: true, branchId: true, unitId: true, departmentId: false };
      case 'ACCESS_DEPARTMENT_LEVEL':
        return { organizationId: true, branchId: true, unitId: true, departmentId: true };
      default:
        return { organizationId: false, branchId: false, unitId: false, departmentId: false };
    }
  };

  // Determina quais campos devem ser bloqueados baseados no usuário logado
  const getBlockedFieldsByCurrentUser = () => {
    const currentUserLevel = getCurrentHierarchyLevel();
    
    switch (currentUserLevel) {
      case 'ORG':
        return { organizationId: true, branchId: false, unitId: false, departmentId: false };
      case 'BRANCH':
        return { organizationId: true, branchId: true, unitId: false, departmentId: false };
      case 'UNIT':
        return { organizationId: true, branchId: true, unitId: true, departmentId: false };
      case 'DEPARTMENT':
        return { organizationId: true, branchId: true, unitId: true, departmentId: true };
      case 'ADMIN':
      default:
        return { organizationId: false, branchId: false, unitId: false, departmentId: false };
    }
  };

  // Limpa campos hierárquicos quando o perfil é alterado
  const handleRoleChange = (role) => {
    const requiredFields = getRequiredFieldsByRole(role);
    
    // Limpa apenas campos hierárquicos que não são obrigatórios para o novo perfil
    const newFormData = { 
      ...formData, 
      role
    };
    
    if (!requiredFields.branchId) {
      newFormData.branchId = '';
    }
    if (!requiredFields.unitId) {
      newFormData.unitId = '';
    }
    if (!requiredFields.departmentId) {
      newFormData.departmentId = '';
    }
    
    console.log('handleRoleChange - editingUser:', editingUser);
    console.log('handleRoleChange - newFormData:', newFormData);
    setFormData(newFormData);
  };

  // Carrega dados na montagem do componente
  useEffect(() => {
    const loadData = async () => {
      try {
        setIsFetching(true);
        
        const hierarchyLevel = getCurrentHierarchyLevel();
        
        // Usa o endpoint de hierarquia para buscar usuários baseado na organização atual
        const hierarchyParams = new URLSearchParams();
        if (orgId) hierarchyParams.append('orgId', orgId);
        if (branchId) hierarchyParams.append('branchId', branchId);
        if (unitId) hierarchyParams.append('unitId', unitId);
        if (departmentId) hierarchyParams.append('departmentId', departmentId);
        
        const promises = [api.get(`/users/hierarchy?${hierarchyParams.toString()}`)];
        
        // Carrega organizações
        if (currentUser?.role === 'ADMIN') {
          promises.push(api.get('/orgs'));
        } else {
          promises.push(Promise.resolve({ data: { organizations: currentOrganization ? [currentOrganization] : [] } }));
        }
        
        // Carrega dados hierárquicos baseado no nível atual
        if (hierarchyLevel === 'ORG' && orgId) {
          promises.push(api.get(`/orgs/${orgId}/branchs`));
        } else if (hierarchyLevel === 'BRANCH' && branchId) {
          promises.push(api.get(`/branchs/${branchId}`));
          promises.push(api.get(`/branchs/${branchId}/units`));
        } else if (hierarchyLevel === 'UNIT' && unitId) {
          promises.push(api.get(`/units/${unitId}`));
          promises.push(api.get(`/units/${unitId}/departments`));
        } else if (hierarchyLevel === 'DEPARTMENT' && departmentId) {
          promises.push(api.get(`/departments/${departmentId}`));
        }
        
        const responses = await Promise.all(promises);
        const allUsers = responses[0].data.users || [];
        const orgs = responses[1].data.organizations || [];
        
        // Processa dados hierárquicos
        if (hierarchyLevel === 'ORG' && responses[2]) {
          setBranches(responses[2].data.branchs || []);
        } else if (hierarchyLevel === 'BRANCH' && responses[2] && responses[3]) {
          setCurrentBranch(responses[2].data);
          setUnits(responses[3].data.units || []);
        } else if (hierarchyLevel === 'UNIT' && responses[2] && responses[3]) {
          setCurrentUnit(responses[2].data);
          setDepartments(responses[3].data.departments || []);
        } else if (hierarchyLevel === 'DEPARTMENT' && responses[2]) {
          setCurrentDepartment(responses[2].data);
        }
        
        setUsers(allUsers);
        setOrganizations(orgs);
        
        // Constrói breadcrumbs baseado no nível hierárquico
        buildBreadcrumbs(hierarchyLevel, responses);
        
        // Aplica filtros salvos após carregar dados
        applyFiltersLocally(allUsers, searchValues['users'] || {});
        
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        toast.error('Erro ao carregar usuários');
      } finally {
        setIsFetching(false);
      }
    };

    loadData();
  }, [currentUser, currentOrganization, orgId, branchId, unitId, departmentId]);

  // Constrói breadcrumbs baseado no nível hierárquico
  const buildBreadcrumbs = (hierarchyLevel, responses) => {
    const breadcrumbs = [];
    
    if (currentUser?.role === 'ADMIN') {
      // ADMIN sempre começa com 'admin'
      breadcrumbs.push({ id: '/', label: 'admin', key: 'admin' });
      
      if (hierarchyLevel === 'ADMIN') {
        breadcrumbs.push({ id: '/usuarios', label: 'Usuários', key: 'admin' });
      } else if (hierarchyLevel === 'ORG' && orgId) {
        const org = organizations.find(o => o.id === orgId) || currentOrganization;
        breadcrumbs.push({ id: orgId, label: org?.name || 'Organização', key: 'org' });
        breadcrumbs.push({ id: `/prefeitura/${orgId}/usuarios`, label: 'Usuários', key: 'admin' });
      } else if (hierarchyLevel === 'BRANCH' && branchId && currentBranch) {
        const org = organizations.find(o => o.id === currentBranch.organizationId) || currentOrganization;
        breadcrumbs.push({ id: org?.id, label: org?.name || 'Organização', key: 'org' });
        breadcrumbs.push({ id: branchId, label: currentBranch.name, key: 'branch' });
        breadcrumbs.push({ id: `/prefeitura/secretaria/${branchId}/usuarios`, label: 'Usuários', key: 'admin' });
      } else if (hierarchyLevel === 'UNIT' && unitId && currentUnit) {
        const org = organizations.find(o => o.id === currentUnit.organizationId) || currentOrganization;
        breadcrumbs.push({ id: org?.id, label: org?.name || 'Organização', key: 'org' });
        breadcrumbs.push({ id: currentUnit.branchId, label: currentUnit.branchName, key: 'branch' });
        breadcrumbs.push({ id: unitId, label: currentUnit.name, key: 'unit' });
        breadcrumbs.push({ id: `/prefeitura/secretaria/unidade/${unitId}/usuarios`, label: 'Usuários', key: 'admin' });
      } else if (hierarchyLevel === 'DEPARTMENT' && departmentId && currentDepartment) {
        const org = organizations.find(o => o.id === currentDepartment.organizationId) || currentOrganization;
        breadcrumbs.push({ id: org?.id, label: org?.name || 'Organização', key: 'org' });
        breadcrumbs.push({ id: currentDepartment.branchId, label: currentDepartment.branchName, key: 'branch' });
        breadcrumbs.push({ id: currentDepartment.unitId, label: currentDepartment.unitName, key: 'unit' });
        breadcrumbs.push({ id: departmentId, label: currentDepartment.name, key: 'department' });
        breadcrumbs.push({ id: `/prefeitura/secretaria/unidade/departamento/${departmentId}/usuarios`, label: 'Usuários', key: 'admin' });
      }
    } else {
      // Usuários não-ADMIN começam com Dashboard
      breadcrumbs.push({ id: '/', label: 'Dashboard', key: 'admin' });
      
      if (hierarchyLevel === 'ORG' && orgId) {
        const org = organizations.find(o => o.id === orgId) || currentOrganization;
        breadcrumbs.push({ id: orgId, label: org?.name || 'Organização', key: 'org' });
        breadcrumbs.push({ id: `/prefeitura/${orgId}/usuarios`, label: 'Usuários', key: 'admin' });
      } else if (hierarchyLevel === 'BRANCH' && branchId && currentBranch) {
        const org = organizations.find(o => o.id === currentBranch.organizationId) || currentOrganization;
        breadcrumbs.push({ id: org?.id, label: org?.name || 'Organização', key: 'org' });
        breadcrumbs.push({ id: branchId, label: currentBranch.name, key: 'branch' });
        breadcrumbs.push({ id: `/prefeitura/secretaria/${branchId}/usuarios`, label: 'Usuários', key: 'admin' });
      } else if (hierarchyLevel === 'UNIT' && unitId && currentUnit) {
        const org = organizations.find(o => o.id === currentUnit.organizationId) || currentOrganization;
        breadcrumbs.push({ id: org?.id, label: org?.name || 'Organização', key: 'org' });
        breadcrumbs.push({ id: currentUnit.branchId, label: currentUnit.branchName, key: 'branch' });
        breadcrumbs.push({ id: unitId, label: currentUnit.name, key: 'unit' });
        breadcrumbs.push({ id: `/prefeitura/secretaria/unidade/${unitId}/usuarios`, label: 'Usuários', key: 'admin' });
      } else if (hierarchyLevel === 'DEPARTMENT' && departmentId && currentDepartment) {
        const org = organizations.find(o => o.id === currentDepartment.organizationId) || currentOrganization;
        breadcrumbs.push({ id: org?.id, label: org?.name || 'Organização', key: 'org' });
        breadcrumbs.push({ id: currentDepartment.branchId, label: currentDepartment.branchName, key: 'branch' });
        breadcrumbs.push({ id: currentDepartment.unitId, label: currentDepartment.unitName, key: 'unit' });
        breadcrumbs.push({ id: departmentId, label: currentDepartment.name, key: 'department' });
        breadcrumbs.push({ id: `/prefeitura/secretaria/unidade/departamento/${departmentId}/usuarios`, label: 'Usuários', key: 'admin' });
      }
    }
    
    setBreadcrumbs(breadcrumbs);
  };

  // Aplica filtros localmente quando searchValues ou headerFilters mudar
  useEffect(() => {
    if (users.length > 0) {
      const base = { ...(searchValues['users'] || {}) };
      const merged = { ...base, ...headerFilters };
      applyFiltersLocally(users, merged);
    }
  }, [searchValues, users, headerFilters]);

  // Função para aplicar filtros localmente
  const applyFiltersLocally = (allUsers, filters) => {
    let filteredUsers = [...allUsers];
    const hierarchyLevel = getCurrentHierarchyLevel();
    
    // Filtro por texto
    if (filters.text && filters.text.trim()) {
      const searchFields = ['name', 'email'];
      const searchText = filters.text.toLowerCase();
      filteredUsers = filteredUsers.filter(user => 
        searchFields.some(field => 
          user[field]?.toLowerCase().includes(searchText)
        )
      );
    }
    
    // Filtro por role
    if (filters.role && filters.role !== '') {
      filteredUsers = filteredUsers.filter(user => {
        const userRole = user.role?.description || user.role;
        return userRole === filters.role;
      });
    }
    
    // Filtragem hierárquica baseada no nível do usuário e contexto atual
    if (currentUser?.role === 'ADMIN') {
      // ADMIN vê todos os usuários, mas pode filtrar por organização se estiver em uma
      if (hierarchyLevel === 'ORG' && orgId) {
        filteredUsers = filteredUsers.filter(user => user.organizationId === orgId);
      } else if (hierarchyLevel === 'BRANCH' && branchId) {
        filteredUsers = filteredUsers.filter(user => 
          user.organizationId === currentBranch?.organizationId && 
          user.branchId === branchId
        );
      } else if (hierarchyLevel === 'UNIT' && unitId) {
        filteredUsers = filteredUsers.filter(user => 
          user.organizationId === currentUnit?.organizationId && 
          user.branchId === currentUnit?.branchId &&
          user.unitId === unitId
        );
      } else if (hierarchyLevel === 'DEPARTMENT' && departmentId) {
        filteredUsers = filteredUsers.filter(user => 
          user.organizationId === currentDepartment?.organizationId && 
          user.branchId === currentDepartment?.branchId &&
          user.unitId === currentDepartment?.unitId &&
          user.departmentId === departmentId
        );
      }
    } else {
      // Usuários não-ADMIN veem apenas usuários da sua hierarquia
      if (hierarchyLevel === 'ORG' && orgId) {
        filteredUsers = filteredUsers.filter(user => user.organizationId === orgId);
      } else if (hierarchyLevel === 'BRANCH' && branchId) {
        filteredUsers = filteredUsers.filter(user => 
          user.organizationId === currentBranch?.organizationId && 
          user.branchId === branchId
        );
      } else if (hierarchyLevel === 'UNIT' && unitId) {
        filteredUsers = filteredUsers.filter(user => 
          user.organizationId === currentUnit?.organizationId && 
          user.branchId === currentUnit?.branchId &&
          user.unitId === unitId
        );
      } else if (hierarchyLevel === 'DEPARTMENT' && departmentId) {
        filteredUsers = filteredUsers.filter(user => 
          user.organizationId === currentDepartment?.organizationId && 
          user.branchId === currentDepartment?.branchId &&
          user.unitId === currentDepartment?.unitId &&
          user.departmentId === departmentId
        );
      } else {
        // Fallback para organização atual
        filteredUsers = filteredUsers.filter(user => 
          user.organizationId === currentOrganization?.id
        );
      }
    }
    
    setSearchUserResult(filteredUsers);
  };

  const handleClearFilters = () => {
    clearPageFilters('users');
    const currentFilters = JSON.parse(localStorage.getItem('filters') || '{}');
    currentFilters.users = { text: '', role: '' };
    localStorage.setItem('filters', JSON.stringify(currentFilters));
    setHeaderFilters({ text: '', role: '' });
  };

  const hasActiveFilters = (headerFilters.text && headerFilters.text.trim()) || (headerFilters.role && headerFilters.role !== '');

  const handleOpenModal = (user = null) => {
    setEditingUser(user);
    const hierarchyLevel = getCurrentHierarchyLevel();
    
    if (user) {
      // Quebra nome completo em nome e sobrenome para o formulário
      const fullName = user.name || '';
      let firstName = user.name || '';
      let lastName = user.lastName || '';
      if (!lastName && fullName.includes(' ')) {
        const parts = fullName.trim().split(/\s+/);
        firstName = parts.slice(0, -1).join(' ') || parts[0];
        lastName = parts.slice(-1).join(' ');
      }

      // Combinar DDD e número em um único campo de telefone formatado
      const phoneDDD = user.phoneDDD || '';
      const phoneNumber = user.phoneNumber || '';
      const fullPhone = phoneDDD && phoneNumber ? `${phoneDDD}${phoneNumber}` : '';
      const formattedPhone = fullPhone ? applyPhoneMask(fullPhone) : '';
      
      setFormData({
        name: firstName || '',
        lastName: lastName || '',
        email: user.email || '',
        docNumber: user.docNumber || '',
        jobTitle: user.jobTitle || '',
        internalCod: user.internalCod || '',
        phoneDDD: user.phoneDDD || '',
        phoneNumber: user.phoneNumber || '',
        role: user.role?.description || user.role || '',
        organizationId: user.organizationId || '',
        branchId: user.branchId || '',
        unitId: user.unitId || '',
        departmentId: user.departmentId || '',
      });
      setPhoneValue(formattedPhone);
    } else {
      // Debug: verificar se currentUser está sendo usado incorretamente
      console.log('Abrindo modal para novo usuário');
      console.log('currentUser:', currentUser);
      // Para novos usuários, define os campos baseados no nível hierárquico atual
      let defaultOrgId = '';
      let defaultBranchId = '';
      let defaultUnitId = '';
      let defaultDepartmentId = '';
      
      if (currentUser?.role === 'ADMIN') {
        // ADMIN pode escolher qualquer valor, mas preenche baseado no contexto atual
        if (hierarchyLevel === 'ORG' && orgId) {
          defaultOrgId = orgId;
        } else if (hierarchyLevel === 'BRANCH' && branchId) {
          defaultOrgId = currentBranch?.organizationId || '';
          defaultBranchId = branchId;
        } else if (hierarchyLevel === 'UNIT' && unitId) {
          defaultOrgId = currentUnit?.organizationId || '';
          defaultBranchId = currentUnit?.branchId || '';
          defaultUnitId = unitId;
        } else if (hierarchyLevel === 'DEPARTMENT' && departmentId) {
          defaultOrgId = currentDepartment?.organizationId || '';
          defaultBranchId = currentDepartment?.branchId || '';
          defaultUnitId = currentDepartment?.unitId || '';
          defaultDepartmentId = departmentId;
        }
      } else {
        // Usuários não-ADMIN devem usar os valores da hierarquia atual
        if (hierarchyLevel === 'ORG' && orgId) {
          defaultOrgId = orgId;
        } else if (hierarchyLevel === 'BRANCH' && branchId) {
          defaultOrgId = currentBranch?.organizationId || currentOrganization?.id || '';
          defaultBranchId = branchId;
        } else if (hierarchyLevel === 'UNIT' && unitId) {
          defaultOrgId = currentUnit?.organizationId || currentOrganization?.id || '';
          defaultBranchId = currentUnit?.branchId || '';
          defaultUnitId = unitId;
        } else if (hierarchyLevel === 'DEPARTMENT' && departmentId) {
          defaultOrgId = currentDepartment?.organizationId || currentOrganization?.id || '';
          defaultBranchId = currentDepartment?.branchId || '';
          defaultUnitId = currentDepartment?.unitId || '';
          defaultDepartmentId = departmentId;
        } else {
          // Fallback para organização atual
          defaultOrgId = currentOrganization?.id || '';
        }
      }
      
      const newFormData = {
        name: '', // Sempre vazio para novos usuários
        lastName: '', // Sempre vazio para novos usuários
        email: '', // Sempre vazio para novos usuários
        docNumber: '', // Sempre vazio para novos usuários
        jobTitle: '', // Sempre vazio para novos usuários
        internalCod: '', // Sempre vazio para novos usuários
        phoneDDD: '', // Sempre vazio para novos usuários
        phoneNumber: '', // Sempre vazio para novos usuários
        role: '',
        organizationId: defaultOrgId,
        branchId: defaultBranchId,
        unitId: defaultUnitId,
        departmentId: defaultDepartmentId,
      };
      
      console.log('FormData sendo definido:', newFormData);
      setFormData(newFormData);
      setPhoneValue('');
    }
    setFormErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingUser(null);
    setFormData({
      name: '', // Sempre vazio ao fechar
      lastName: '', // Sempre vazio ao fechar
      email: '', // Sempre vazio ao fechar
      docNumber: '', // Sempre vazio ao fechar
      jobTitle: '', // Sempre vazio ao fechar
      internalCod: '', // Sempre vazio ao fechar
      phoneDDD: '', // Sempre vazio ao fechar
      phoneNumber: '', // Sempre vazio ao fechar
      role: '',
      organizationId: '',
      branchId: '',
      unitId: '',
      departmentId: '',
    });
    setPhoneValue('');
    setFormErrors({});
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name.trim()) {
      errors.name = 'Nome é obrigatório';
    }
    
    if (!formData.email.trim()) {
      errors.email = 'Email é obrigatório';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email inválido';
    }
    
    if (!formData.docNumber.trim()) {
      errors.docNumber = 'Documento é obrigatório';
    }
    
    if (!formData.role) {
      errors.role = 'Perfil é obrigatório';
    }
    
    // Validação baseada no perfil selecionado
    const requiredFields = getRequiredFieldsByRole(formData.role);
    if (requiredFields.organizationId && !formData.organizationId) {
      errors.organizationId = 'Organização é obrigatória para este perfil';
    }
    if (requiredFields.branchId && !formData.branchId) {
      errors.branchId = 'Secretaria é obrigatória para este perfil';
    }
    if (requiredFields.unitId && !formData.unitId) {
      errors.unitId = 'Unidade é obrigatória para este perfil';
    }
    if (requiredFields.departmentId && !formData.departmentId) {
      errors.departmentId = 'Departamento é obrigatório para este perfil';
    }
    
    // Senha será gerada automaticamente pelo backend
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      // Processar telefone formatado
      const phoneNumbers = phoneValue.replace(/\D/g, '');
      const phoneDDD = phoneNumbers.slice(0, 2);
      const phoneNumber = phoneNumbers.slice(2);

      const fullName = [formData.name.trim(), formData.lastName.trim()].filter(Boolean).join(' ');
      const userData = {
        name: fullName,
        email: formData.email.trim(),
        document: formData.docNumber.trim(),
        roleId: enumUserRole[formData.role], // Converte string para ID numérico
        orgRef: formData.organizationId,
        status: formData.status ?? true, // Usuário ativo por padrão
        jobTitle: formData.jobTitle.trim(),
        internalCod: formData.internalCod.trim(),
        phoneDDD: phoneDDD,
        phoneNumber: phoneNumber,
        // Campos de hierarquia
        organizationId: formData.organizationId,
        branchId: formData.branchId || null,
        unitId: formData.unitId || null,
        departmentId: formData.departmentId || null,
      };

      // Para usuários não-ADMIN, força o uso dos valores da hierarquia atual
      if (currentUser?.role !== 'ADMIN') {
        const hierarchyLevel = getCurrentHierarchyLevel();
        userData.organizationId = currentOrganization?.id;
        
        if (hierarchyLevel === 'BRANCH' && branchId) {
          userData.branchId = branchId;
        } else if (hierarchyLevel === 'UNIT' && unitId) {
          userData.branchId = currentUnit?.branchId;
          userData.unitId = unitId;
        } else if (hierarchyLevel === 'DEPARTMENT' && departmentId) {
          userData.branchId = currentDepartment?.branchId;
          userData.unitId = currentDepartment?.unitId;
          userData.departmentId = departmentId;
        }
      }

      // Ajusta campos hierárquicos à luz do perfil selecionado
      const required = getRequiredFieldsByRole(formData.role);
      if (!required.branchId) userData.branchId = null;
      if (!required.unitId) userData.unitId = null;
      if (!required.departmentId) userData.departmentId = null;

      // Senha será gerada automaticamente pelo backend

      if (editingUser) {
        await api.patch(`/users/${editingUser.id}`, userData);
        toast.success('Usuário atualizado com sucesso!');
      } else {
        await api.post('/users', userData);
        toast.success('Usuário criado com sucesso!');
      }

      // Recarrega a lista de usuários
      const hierarchyParams = new URLSearchParams();
      if (orgId) hierarchyParams.append('orgId', orgId);
      if (branchId) hierarchyParams.append('branchId', branchId);
      if (unitId) hierarchyParams.append('unitId', unitId);
      if (departmentId) hierarchyParams.append('departmentId', departmentId);
      
      const response = await api.get(`/users/hierarchy?${hierarchyParams.toString()}`);
      const allUsers = response.data.users || [];
      setUsers(allUsers);
      applyFiltersLocally(allUsers, searchValues['users'] || {});
      
      handleCloseModal();
    } catch (error) {
      console.error('Erro ao salvar usuário:', error);
      
      // Tratamento de erros específicos
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || 'Erro ao salvar usuário';
      const errorData = error.response?.data;
      
      console.log('Erro completo:', { errorMessage, errorData, error });
      
      // Verifica se é erro de email já cadastrado
      if (errorMessage.includes('email já cadastrado') || 
          errorMessage.includes('email already exists') ||
          errorMessage.includes('Unique constraint failed on the constraint: `User_email_key`') ||
          (errorData && errorData.code === 'P2002' && errorData.meta?.target?.includes('email'))) {
        toast.error('Este e-mail já está cadastrado no sistema');
        setFormErrors(prev => ({ ...prev, email: 'Este e-mail já está cadastrado' }));
      }
      // Verifica se é erro de documento já cadastrado
      else if (errorMessage.includes('documento já cadastrado') || 
               errorMessage.includes('document already exists') || 
               errorMessage.includes('Unique constraint failed on the constraint: `User_docNumber_key`') ||
               (errorData && errorData.code === 'P2002' && errorData.meta?.target?.includes('docNumber'))) {
        toast.error('Este CPF já está cadastrado no sistema');
        setFormErrors(prev => ({ ...prev, docNumber: 'Este CPF já está cadastrado' }));
      }
      // Verifica se é erro de constraint única (Prisma P2002) genérico
      else if (errorMessage.includes('Unique constraint failed') || 
               (errorData && errorData.code === 'P2002')) {
        const target = errorData?.meta?.target || [];
        if (target.includes('docNumber')) {
          toast.error('Este CPF já está cadastrado no sistema');
          setFormErrors(prev => ({ ...prev, docNumber: 'Este CPF já está cadastrado' }));
        } else if (target.includes('email')) {
          toast.error('Este e-mail já está cadastrado no sistema');
          setFormErrors(prev => ({ ...prev, email: 'Este e-mail já está cadastrado' }));
        } else {
          toast.error('Dados já existem no sistema');
        }
      }
      // Outros erros
      else {
        toast.error(errorMessage);
      }
    }
  };

  const handleDelete = async (userId) => {
    if (window.confirm('Tem certeza que deseja excluir este usuário?')) {
      try {
        await api.delete(`/users/${userId}`);
        toast.success('Usuário excluído com sucesso!');
        
        // Recarrega a lista de usuários
        const hierarchyParams = new URLSearchParams();
        if (orgId) hierarchyParams.append('orgId', orgId);
        if (branchId) hierarchyParams.append('branchId', branchId);
        if (unitId) hierarchyParams.append('unitId', unitId);
        if (departmentId) hierarchyParams.append('departmentId', departmentId);
        
        const response = await api.get(`/users/hierarchy?${hierarchyParams.toString()}`);
        const allUsers = response.data.users || [];
        setUsers(allUsers);
        applyFiltersLocally(allUsers, searchValues['users'] || {});
      } catch (error) {
        console.error('Erro ao excluir usuário:', error);
        toast.error('Erro ao excluir usuário');
      }
    }
  };

  // Status agora será alterado dentro do modal de edição

  const getRoleDisplayName = (role) => {
    const roleMap = {
      'ADMIN': 'Administrador',
      'ACCESS_STAFF': 'Staff',
      'ACCESS_ORG_LEVEL': 'Nível Organização',
      'ACCESS_BRANCH_LEVEL': 'Nível Secretaria',
      'ACCESS_UNIT_LEVEL': 'Nível Unidade',
      'ACCESS_DEPARTMENT_LEVEL': 'Nível Departamento',
    };
    return roleMap[role] || role;
  };

  const canEditUser = (user) => {
    // ADMIN pode editar qualquer usuário
    if (currentUser?.role === 'ADMIN') {
      return true;
    }
    
    // Outros níveis só podem editar usuários da mesma organização
    return user.organization?.id === currentOrganization?.id;
  };

  const canDeleteUser = (user) => {
    // Não pode deletar a si mesmo
    if (user.id === currentUser?.id) {
      return false;
    }
    
    // ADMIN pode deletar qualquer usuário
    if (currentUser?.role === 'ADMIN') {
      return true;
    }
    
    // Outros níveis só podem deletar usuários da mesma organização
    return user.organization?.id === currentOrganization?.id;
  };

  return (
    <>
      <Breadcrumbs id='breadcrumbs-users' path={breadcrumbs} />
      <Page id='page-users' title='Usuários'>
        <UsersHeader id='users-header'>
          <GridFilterSection id='users-filter-section'>
            <FilterContainer id='users-filter-container'>
              <FilterInputContainer id='users-filter-input-container'>
                <CustomInputGroup id='users-search-input'>
                  <SearchIconBox>
                    <MdSearch />
                  </SearchIconBox>
                  <CustomFormControl
                    id='users-filter-text'
                    type="text"
                    placeholder="Buscar por nome ou e-mail..."
                    value={headerFilters.text}
                    onChange={(e) => setHeaderFilters(prev => ({ ...prev, text: e.target.value }))}
                  />
                </CustomInputGroup>
              </FilterInputContainer>

              <FilterSelectContainer id='users-filter-role-container'>
                <CustomSelectRounded
                  id='users-filter-role'
                  value={headerFilters.role}
                  onChange={(e) => setHeaderFilters(prev => ({ ...prev, role: e.target.value }))}
                >
                  <option value="">Busque por perfil...</option>
                  {Object.keys(enumUserRole).map(key => (
                    <option key={key} value={key}>{getRoleDisplayName(key)}</option>
                  ))}
                </CustomSelectRounded>
              </FilterSelectContainer>
            </FilterContainer>
          </GridFilterSection>

          <ButtonGroup>
            {hasActiveFilters && (
              <CustomButton id='users-clear-filters-btn' onClick={handleClearFilters}>
                <MdFilterList />
                Limpar filtros
              </CustomButton>
            )}
            <CustomButton id='add-user-btn' onClick={() => handleOpenModal()}>
              <BsPlus />
              Novo usuário
            </CustomButton>
          </ButtonGroup>
        </UsersHeader>

        <Container id='users-table-container'>
          <TableBox className='table-responsive'>
            <CustomTable id='users-table'>
              <CustomTableHead id='users-table-head'>
                <CustomTableRow id='users-table-head-row'>
                  <CustomTH id='th-nome'>Nome</CustomTH>
                  <CustomTH id='th-email'>E-mail</CustomTH>
                  <CustomTH id='th-perfil'>Perfil</CustomTH>
                  <CustomTH id='th-organizacao'>Organização</CustomTH>
                  <CustomTH id='th-secretaria'>Secretaria</CustomTH>
                  <CustomTH id='th-unidade'>Unidade</CustomTH>
                  <CustomTH id='th-departamento'>Departamento</CustomTH>
                  <CustomTH id='th-status'>Status</CustomTH>
                  <ActionsTH id='th-acoes'></ActionsTH>
                </CustomTableRow>
              </CustomTableHead>
              <CustomTableBody id='users-table-body'>
                {isFetching ? (
                  [0,1,2,3,4].map(item => (
                    <CustomTableRow key={`skeleton-row-${item}`} id={`skeleton-row-${item}`}>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '120px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '160px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '90px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '140px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '120px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '120px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '140px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD></CustomTD>
                    </CustomTableRow>
                  ))
                ) : (
                  (searchUserResult.length > 0 ? searchUserResult : []).map((user) => (
                    <CustomTableRow id={`users-row-${user.id}`} key={user.id}>
                      <CustomTD id={`user-name-${user.id}`}>{user.name}</CustomTD>
                      <CustomTD id={`user-email-${user.id}`}>{user.email}</CustomTD>
                      <CustomTD id={`user-role-${user.id}`}>{getRoleDisplayName(user.role?.description || user.role)}</CustomTD>
                      <CustomTD id={`user-org-${user.id}`}>{user.organization?.name || 'N/A'}</CustomTD>
                      <CustomTD id={`user-branch-${user.id}`}>{user.branchName || 'N/A'}</CustomTD>
                      <CustomTD id={`user-unit-${user.id}`}>{user.unitName || 'N/A'}</CustomTD>
                      <CustomTD id={`user-department-${user.id}`}>{user.departmentName || 'N/A'}</CustomTD>
                      <CustomTD id={`user-status-${user.id}`}>
                        <StatusBadge className={`status-${user.status ? 'active' : 'inactive'}`}>
                          {user.status ? 'Ativo' : 'Inativo'}
                        </StatusBadge>
                      </CustomTD>
                      <CustomTD className='text-center'>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                          {canEditUser(user) && (
                            <ListActionButton id={`edit-user-${user.id}`} className='action-button secondary' onClick={() => handleOpenModal(user)}>
                              <BsPencil />
                              Editar
                            </ListActionButton>
                          )}
                        </div>
                      </CustomTD>
                    </CustomTableRow>
                  ))
                )}
              </CustomTableBody>
            </CustomTable>
          </TableBox>
          {!isFetching && searchUserResult.length === 0 && (
            <UsersContainer id='user-no-results'>
              <NoResults id='no-results-users' message='Nenhum usuário encontrado' searchText={headerFilters.text} />
            </UsersContainer>
          )}
        </Container>

        {/* Modal de Cadastro/Edição */}
        <Modal id='user-modal' show={showModal} onHide={handleCloseModal} size='lg'>
          <ModalHeader id='user-modal-header' closeButton>
            <Modal.Title>
              {editingUser ? 'Editar Usuário' : 'Novo Usuário'}
            </Modal.Title>
          </ModalHeader>
          <Form onSubmit={handleSubmit}>
            <ModalBody id='user-modal-body'>
              {/* Nome | Sobrenome */}
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label htmlFor='user-name'>Nome *</Label>
                    <Input
                      id='user-name'
                      type='text'
                      value={formData.name}
                      onChange={(e) => {
                        setFormData({ ...formData, name: e.target.value });
                        clearFieldError('name');
                      }}
                      isInvalid={!!formErrors.name}
                      style={{ height: '40px' }}
                    />
                    {formErrors.name && (
                      <div className='text-danger small mt-1' style={{ fontSize: '0.875rem' }}>
                        {formErrors.name}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label htmlFor='user-lastname'>Sobrenome</Label>
                    <Input
                      id='user-lastname'
                      type='text'
                      value={formData.lastName}
                      onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                      style={{ height: '40px' }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              
              {/* E-mail | Telefone | Status */}
              <Row>
                <Col sm={4}>
                  <FormGroup>
                    <Label htmlFor='user-email'>E-mail *</Label>
                    <Input
                      id='user-email'
                      type='email'
                      value={formData.email}
                      onChange={(e) => {
                        setFormData({ ...formData, email: e.target.value });
                        clearFieldError('email');
                      }}
                      isInvalid={!!formErrors.email}
                      disabled={!!editingUser}
                      title={editingUser ? 'E-mail não pode ser alterado na edição' : ''}
                      style={{ height: '40px' }}
                    />
                    {formErrors.email && (
                      <div className='text-danger small mt-1' style={{ fontSize: '0.875rem' }}>
                        {formErrors.email}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup>
                    <Label htmlFor='user-phone'>Telefone</Label>
                    <Input
                      id='user-phone'
                      type='text'
                      value={phoneValue}
                      onChange={(e) => {
                        const maskedValue = applyPhoneMask(e.target.value);
                        setPhoneValue(maskedValue);
                      }}
                      placeholder='(11) 99999-9999'
                      style={{ height: '40px' }}
                    />
                  </FormGroup>
                </Col>
                {editingUser && (
                  <Col sm={4}>
                    <FormGroup>
                      <Label htmlFor='user-status'>Status</Label>
                      <Select
                        id='user-status'
                        value={(formData.status ?? editingUser?.status ?? true) ? 'true' : 'false'}
                        onChange={(e) => setFormData({ ...formData, status: e.target.value === 'true' })}
                        style={{ height: '40px', padding: '10px' }}
                      >
                        <option value={'true'}>Ativo</option>
                        <option value={'false'}>Inativo</option>
                      </Select>
                    </FormGroup>
                  </Col>
                )}
              </Row>

              {/* Código Interno | Cargo */}
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label htmlFor='user-internal-cod'>Código Interno</Label>
                    <Input
                      id='user-internal-cod'
                      type='text'
                      value={formData.internalCod}
                      onChange={(e) => setFormData({ ...formData, internalCod: e.target.value })}
                      placeholder='Código interno do usuário'
                      style={{ height: '40px' }}
                    />
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label htmlFor='user-job-title'>Cargo</Label>
                    <Input
                      id='user-job-title'
                      type='text'
                      value={formData.jobTitle}
                      onChange={(e) => setFormData({ ...formData, jobTitle: e.target.value })}
                      placeholder='Ex: Analista, Coordenador, etc.'
                      style={{ height: '40px' }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              {/* CPF | Perfil */}
                    <Row>
                    <Col sm={6}>
                  <FormGroup>
                    <Label htmlFor='user-doc-number'>CPF *</Label>
                    <Input
                      id='user-doc-number'
                      type='text'
                      value={formatCPF(formData.docNumber)}
                      onChange={(e) => {
                        const numbers = e.target.value.replace(/\D/g, '');
                        setFormData({ ...formData, docNumber: numbers });
                        clearFieldError('docNumber');
                      }}
                      isInvalid={!!formErrors.docNumber}
                      placeholder='000.000.000-00'
                      maxLength={14}
                      style={{ height: '40px' }}
                    />
                    {formErrors.docNumber && (
                      <div className='text-danger small mt-1' style={{ fontSize: '0.875rem' }}>
                        {formErrors.docNumber}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor='user-role'>Perfil *</Label>
                    <Select
                      id='user-role'
                      value={formData.role}
                      onChange={(e) => {
                        handleRoleChange(e.target.value);
                        clearFieldError('role');
                      }}
                      isInvalid={!!formErrors.role}
                      style={{ height: '40px', padding: '10px' }}
                    >
                      <option value=''>Selecione um perfil...</option>
                      {Object.keys(enumUserRole).map(role => (
                        <option key={role} value={role}>
                          {getRoleDisplayName(role)}
                        </option>
                      ))}
                    </Select>
                    {formErrors.role && (
                      <div className='text-danger small mt-1' style={{ fontSize: '0.875rem' }}>
                        {formErrors.role}
                      </div>
                    )}
                  </FormGroup>
                </Col>
              </Row>

              

              {/* Campos hierárquicos - duas colunas por linha */}
              {formData.role && (
                <>
                  <Row>
                    {/* Organização */}
                    {['ACCESS_ORG_LEVEL', 'ACCESS_BRANCH_LEVEL', 'ACCESS_UNIT_LEVEL', 'ACCESS_DEPARTMENT_LEVEL'].includes(formData.role) && (
                      <Col sm={6}>
                        <FormGroup>
                          <Label htmlFor='user-organization'>
                            Organização *
                          </Label>
                          {getBlockedFieldsByCurrentUser().organizationId ? (
                            <div id='user-organization-display' className='form-control' style={{
                              backgroundColor: '#f8f9fa',
                              border: '1px solid #ced4da',
                              padding: '0.375rem 0.75rem',
                              borderRadius: '0.375rem',
                              color: '#6c757d',
                              height: '40px',
                              display: 'flex',
                              alignItems: 'center'
                            }}>
                              {(() => {
                                const orgId = formData.organizationId;
                                const org = organizations.find(o => o.id === orgId) || currentOrganization;
                                return org?.name || 'Organização não encontrada';
                              })()}
                            </div>
                          ) : (
                            <Select
                              id='user-organization'
                              value={formData.organizationId}
                              onChange={(e) => {
                                setFormData({ ...formData, organizationId: e.target.value });
                                clearFieldError('organizationId');
                              }}
                              isInvalid={!!formErrors.organizationId}
                              style={{ height: '40px', padding: '10px' }}
                            >
                              <option value=''>Selecione uma organização...</option>
                              {organizations.map(org => (
                                <option key={org.id} value={org.id}>
                                  {org.name}
                                </option>
                              ))}
                            </Select>
                          )}
                          {formErrors.organizationId && (
                            <div className='text-danger small mt-1' style={{ fontSize: '0.875rem' }}>
                              {formErrors.organizationId}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    )}

                    {/* Secretaria */}
                    {['ACCESS_BRANCH_LEVEL', 'ACCESS_UNIT_LEVEL', 'ACCESS_DEPARTMENT_LEVEL'].includes(formData.role) && (
                      <Col sm={6}>
                        <FormGroup>
                          <Label htmlFor='user-branch'>
                            Secretaria *
                          </Label>
                          <Select
                            id='user-branch'
                            value={formData.branchId}
                            onChange={async (e) => {
                              const selectedBranchId = e.target.value;
                              setFormData({ ...formData, branchId: selectedBranchId, unitId: '', departmentId: '' });
                              clearFieldError('branchId');
                              if (selectedBranchId) {
                                try {
                                  const response = await api.get(`/branchs/${selectedBranchId}/units`);
                                  setUnits(response.data.units || []);
                                } catch (error) {
                                  console.error('Erro ao carregar unidades:', error);
                                  setUnits([]);
                                }
                              } else {
                                setUnits([]);
                              }
                            }}
                            isInvalid={!!formErrors.branchId}
                            disabled={getBlockedFieldsByCurrentUser().branchId}
                            style={{ height: '40px', padding: '10px' }}
                          >
                            <option value=''>Selecione uma secretaria...</option>
                            {branches.map(branch => (
                              <option key={branch.id} value={branch.id}>
                                {branch.name}
                              </option>
                            ))}
                          </Select>
                          {formErrors.branchId && (
                            <div className='text-danger small mt-1' style={{ fontSize: '0.875rem' }}>
                              {formErrors.branchId}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    )}
                  </Row>

                  <Row>
                    {/* Unidade */}
                    {['ACCESS_UNIT_LEVEL', 'ACCESS_DEPARTMENT_LEVEL'].includes(formData.role) && (
                      <Col sm={6}>
                        <FormGroup>
                          <Label htmlFor='user-unit'>
                            Unidade *
                          </Label>
                          <Select
                            id='user-unit'
                            value={formData.unitId}
                            onChange={async (e) => {
                              const selectedUnitId = e.target.value;
                              setFormData({ ...formData, unitId: selectedUnitId, departmentId: '' });
                              clearFieldError('unitId');
                              if (selectedUnitId) {
                                try {
                                  const response = await api.get(`/units/${selectedUnitId}/departments`);
                                  setDepartments(response.data.departments || []);
                                } catch (error) {
                                  console.error('Erro ao carregar departamentos:', error);
                                  setDepartments([]);
                                }
                              } else {
                                setDepartments([]);
                              }
                            }}
                            isInvalid={!!formErrors.unitId}
                            disabled={getBlockedFieldsByCurrentUser().unitId}
                            style={{ height: '40px', padding: '10px' }}
                          >
                            <option value=''>Selecione uma unidade...</option>
                            {units.map(unit => (
                              <option key={unit.id} value={unit.id}>
                                {unit.name}
                              </option>
                            ))}
                          </Select>
                          {formErrors.unitId && (
                            <div className='text-danger small mt-1' style={{ fontSize: '0.875rem' }}>
                              {formErrors.unitId}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    )}

                    {/* Departamento */}
                    {formData.role === 'ACCESS_DEPARTMENT_LEVEL' && (
                      <Col sm={6}>
                        <FormGroup>
                          <Label htmlFor='user-department'>
                            Departamento *
                            {getBlockedFieldsByCurrentUser().departmentId && (
                              <small className='text-muted d-block'>
                                (Definido automaticamente baseado no seu perfil)
                              </small>
                            )}
                          </Label>
                          <Select
                            id='user-department'
                            value={formData.departmentId}
                            onChange={(e) => {
                              setFormData({ ...formData, departmentId: e.target.value });
                              clearFieldError('departmentId');
                            }}
                            isInvalid={!!formErrors.departmentId}
                            disabled={getBlockedFieldsByCurrentUser().departmentId}
                            style={{ height: '40px', padding: '10px' }}
                          >
                            <option value=''>Selecione um departamento...</option>
                            {departments.map(dept => (
                              <option key={dept.id} value={dept.id}>
                                {dept.name}
                              </option>
                            ))}
                          </Select>
                          {formErrors.departmentId && (
                            <div className='text-danger small mt-1' style={{ fontSize: '0.875rem' }}>
                              {formErrors.departmentId}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                </>
              )}

              {/* Senha será gerada automaticamente pelo backend */}
            </ModalBody>
            <ModalFooter id='user-modal-footer'>
              <Button variant='light' onClick={handleCloseModal}>
                Cancelar
              </Button>
              <Button variant='primary' type='submit'>
                {editingUser ? 'Atualizar' : 'Criar'}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Page>
    </>
  );
};

export default PageUsers;
